import { AlphaCBoxOutlineIcon } from './AlphaCBoxOutlineIcon';

/**
 * author: Contributors
 * id 9EB832F8-B389-47AA-ADDA-A2163E75DC20
 * name alpha-c-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-c-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetCBoxOutlineIcon = AlphaCBoxOutlineIcon;
export default AlphabetCBoxOutlineIcon